import ContentScreen from './ContentScreen'

export default ContentScreen
